var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('v-row',[_c('v-col',{staticClass:"tw-p-0 tw-m-0",attrs:{"align":"center"}},[_c('apexchart',{staticClass:"tw-p-0 tw-m-0",attrs:{"options":_vm.options,"series":_vm.options.series,"type":_vm.options.chart.type,"width":"90%"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }